import {
  Duration,
  PriorityLevel,
  TaskTemplateForm,
} from '@dispatch/shared/types';

const APIMock: TaskTemplateForm = {
  externalId: '123456',
  name: 'Default Task Templates',
  description: 'First task template',
  id: '123456',
  editedAt: null,
  createdAt: null,
  deactivatedAt: null,
  deletedAt: null,
  timesUsed: 0,
  rolePriorities: [
    {
      id: 'b34a57ab-1198-4fd3-a1fd-ac58211a8416',
      order: 0,
    },
  ],
  sloInMinutes: '30',
  priorityLevel: PriorityLevel.HIGH,
  isTravelRequired: true,
  attributes: [
    {
      attribute: 'Perils',
      name: 'Perils',
      value: 'Water',
      cat: 'required',
      nonCat: 'none',
      useProficiency: true,
      minimumProficiency: 1,
      isPrepopulated: true,
    },
    {
      attribute: 'Estimating',
      name: 'Estimating',
      value: 'Interior Estimating',
      cat: 'preferred',
      nonCat: 'required',
      useProficiency: true,
      minimumProficiency: 2,
      isPrepopulated: false,
    },
  ],
  isStateLicenseRequired: true,
  ruleDescription: 'handle SE hurricanes',
  targetTaskGroupId: '1234',
  condition: '@and',
  rules: [
    {
      ifThis: '$msg.claim.lossLocation.state',
      operator: '@in_list',
      meta: ['CA'],
    },
    {
      ifThis: '$msg.claim.peril',
      operator: '@in_list',
      meta: ['01', '03'],
    },
  ],
  durations: [
    {
      peril: '',
      duration: Duration.L,
    },
  ],
};

export const taskTemplatesMock: TaskTemplateForm = APIMock;

export const mockPerils = [
  {
    title: 'Aircraft',
    value: '01',
  },
  {
    title: 'Earthquake',
    value: '03',
  },
  {
    title: 'Explosion',
    value: '04',
  },
];

export const mockTaskGroup = [
  {
    title: 'new group 2',
    value: '1234',
  },
];

export const mockCompanyRole = [
  {
    value: 'b34a57ab-1198-4fd3-a1fd-ac58211a8416',
    title: 'Adjuster(Archive)',
  },
  {
    value: 'f9a764e7-abe2-4dd9-af76-095e2001becc',
    title: 'Adjuster-Staff',
  },
  {
    value: 'fa42c3de-6591-460d-8986-c75062b379ce',
    title: 'Adjuster-Contingent',
  },
];

export const mockAttributeDefinitions: any[] = [
  {
    value: 'Estimating',
    title: 'Estimating',
    valueType: 'multi-select',
    attributeDefinitionValues: [
      {
        value: 'Interior Estimating',
        title: 'Interior Estimating',
        definitionValue: {
          id: 1,
          integrationGUID: 'a79a39c2-d700-4ebf-9cb9-909b8ee0007c',
          attributeDefinitionId: 1,
          displayName: 'Interior Estimating',
          value: 'Test',
        },
      },
    ],
  },
  {
    value: 'Perils',
    title: 'Perils',
    valueType: 'multi-select',
    attributeDefinitionValues: [
      {
        value: 'Water',
        title: 'Water',
        definitionValue: {
          id: 8,
          integrationGUID: 'a0eb5536-7a41-4401-9efe-ecd6be43f378',
          attributeDefinitionId: 2,
          displayName: 'Water',
          value: 'Test',
        },
      },
    ],
    definition: {
      id: 2,
      integrationGUID: '0d334ea2-d739-427b-8324-857e537b8464',
      displayName: 'Perils',
      isActive: true,
      attributeDefinitionValues: [
        {
          id: 8,
          integrationGUID: 'a0eb5536-7a41-4401-9efe-ecd6be43f378',
          attributeDefinitionId: 2,
          displayName: 'Water',
          value: 'Test',
        },
      ],
    },
  },
];
